import _ from 'lodash';
import moment from 'moment';

export default {
  filters: {
    largeNumber(num, dec = 0) {
      let ret = num;

      if (num > 999999) {
        ret = `${(num / 1000000).toFixed(dec)}M`;
      } else if (num > 999) {
        ret = `${(num / 1000).toFixed(dec)}K`;
      }

      return ret;
    },
  },
  methods: {
    showWarning(msg) {
      this.$root.toggleWarning = true;
      this.$root.warningMsg = msg;
    },
    isExpired(isoDate) {
      return moment(isoDate).isBefore();
    },
    sort(a, b, key) {
      const ak = _.get(a, key, '');
      const bk = _.get(b, key, '');

      // If both compared fields are native numbers
      if (typeof ak === 'number' && typeof bk === 'number') {
        // eslint-disable-next-line
        return ak < bk ? -1 : (ak > bk ? 1 : 0);
      }

      // If both compared fields are arrays
      if (Array.isArray(ak) && Array.isArray(bk)) {
        // eslint-disable-next-line
        return ak.length < bk.length ? -1 : (ak.length > bk.length ? 1 : 0);
      }

      // If both compared fields are moment objects
      if (moment.isMoment(ak) && moment.isMoment(bk)) {
        // eslint-disable-next-line
        return ak < bk ? 1 : (ak > bk ? -1 : 0);
      }

      // Stringify the field data and use String.localeCompare
      return ak.toString().localeCompare(bk.toString(), undefined, {
        numeric: true,
      });
    },
  },
};
